const kpi = {
  title: 'Estáticas atuais', 
};

export default kpi;